import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styles from 'wienenergiedesignsystem/components/Heading/Heading.module.scss';
import React from 'react';
import classNames from 'classnames';
var Heading = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;

  var as = _ref.as,
      children = _ref.children,
      size = _ref.size,
      noSpacing = _ref.noSpacing,
      notResponsive = _ref.notResponsive,
      className = _ref.className,
      align = _ref.align,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "children", "size", "noSpacing", "notResponsive", "className", "align", "theme"]);

  var Element = {
    as: as || size
  };
  return /*#__PURE__*/React.createElement(Element.as, Object.assign({
    ref: ref,
    className: classNames(styles.heading, className, styles[size], styles[theme], styles[align], (_classNames = {}, _classNames[styles.noSpacing] = noSpacing, _classNames[styles.notResponsive] = notResponsive, _classNames)) // eslint-disable-next-line react/no-children-prop
    ,
    children: children || null
  }, props));
});
Heading.defaultProps = {
  as: null,
  theme: 'default',
  size: 'h1',
  align: null,
  noSpacing: false,
  notResponsive: false,
  className: '',
  children: ''
};
export default Heading;